<template>
    	<!-- Main Wrapper -->
        <div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Sidebar -->
                <layout-sidebar />
			<!-- /Sidebar -->
			
			<!-- Page Wrapper -->
            <div class="page-wrapper">
			
				<!-- Page Content -->
                <div class="content container-fluid">
					
					<!-- Page Header -->
					<div class="page-header">
						<div class="row">
							<div class="col-sm-12">
								<h3 class="page-title">Attendance Reports</h3>
								<ul class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Dashboard</router-link></li>
									<li class="breadcrumb-item active">Attendance Reports</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /Page Header -->
					
						<!-- Content Starts -->
						<!-- Search Filter -->
					<div class="row filter-row">
						
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus">
								<input type="text" class="form-control floating">
								<label class="focus-label">Employee Name</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus">
								<div class="cal-icon">
									<select class="form-control floating select">
										<option>
											Management
										</option>
										<option>
											Finance
										</option>
										<option>
											Development
										</option>
									</select>
								</div>
								<label class="focus-label">Department</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus">
								<div class="cal-icon">
									<select class="form-control floating select">
										<option>
											All
										</option>
										<option>
											CEO
										</option>
										<option>
											Finance
										</option>
									</select>
								</div>
								<label class="focus-label">Designation</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<a href="#" class="btn btn-success btn-block"> Search </a>  
						</div>     
                    </div>
					<!-- /Search Filter -->
							<div class="card card-table mt-3">
								<div class="card-body">
									<div class="table-responsive">
										<table class="table table-hover table-center mb-0">
											<thead>
												<tr>
													<th>Employee</th>
													<th>Date</th>
													<th class="text-center">Total Working days</th>
													<th class="text-center">Workday by Employee</th>
													<th class="text-center">Late Arrival</th>
													<th class="text-center">Missing Work</th>
													<th class="text-center">Night Hrs</th>
													<th class="text-center">Extra Time</th>
													<th>Leave Count for This Month</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
														<h2 class="table-avatar">
															<router-link to="/profile" class="avatar avatar-sm mr-2"><img class="avatar-img rounded-circle" src="@/assets/profiles/avatar-03.jpg" alt="User Image"></router-link>
															<router-link to="/profile">Justin Lee <span>#0001</span></router-link>
														</h2>
													</td>
													<td>20 Dec 2020</td>
													<td class="text-center">
														<button class="btn btn-outline-info btn-sm">28</button>
													</td>
													<td class="text-center"><span class="btn btn-danger btn-sm">26</span></td>
													<td class="text-center"><span class="btn btn-warning btn-sm"><b>15 min</b></span></td>
													<td class="text-center"><span class="btn btn-success btn-sm"><b>No Work missing</b></span></td>
													<td class="text-center">3 hrs</td>
													<td class="text-center">2 hrs</td>
													<td class="text-center"><span class="btn btn-danger btn-sm">02</span></td>
												</tr>
											
											</tbody>
										</table>
									</div>
								</div>
							</div>
					
                
					<!-- /Content End -->
					
                </div>
				<!-- /Page Content -->
				
            </div>
			<!-- /Page Wrapper -->
			
        </div>
		<!-- /Main Wrapper -->
</template>

<script>
    export default {
        mounted() {
            // Select 2
            if ($('.select').length > 0) {
                $('.select').select2({
                    minimumResultsForSearch: -1,
                    width: '100%'
                });
            }
        },
        name: 'projectreports'
    }
</script>


// WEBPACK FOOTER //
// src/components/attendreports.vue